import Footer from "../footer/footer";
import Navbar from "../navbar/navbar";
import Fire from '../../assets/Fire Tube Boiler.png';
import Electric from '../../assets/Electric Steam Boiler.png';
import WaterTube from '../../assets/Water Tube Boiler.png';
import Banner from '../../assets/Boilers.jpg';
import { Helmet } from "react-helmet";
import React from "react";
import {
    FaIndustry,
    FaGasPump,
    FaTools,
    FaCertificate,
    FaCogs,
    FaChartLine,
    FaShieldAlt,
    FaHeadset,
    FaCubes,
    FaCheck
} from "react-icons/fa";
import { HiOutlineBadgeCheck } from "react-icons/hi";
import { FaOilWell } from "react-icons/fa6";

const Boilers: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>Industrial Steam Boilers Manufacturer India | Fire Tube, Water Tube & Electric Boilers</title>
                <meta
                    name="description"
                    content="ASME-certified industrial steam boiler manufacturer in India. Fire Tube, Water Tube & Electric Boilers for oil, gas, and power industries. Energy-efficient & high-pressure."
                />
                <meta
                    name="keywords"
                    content=" industrial steam boilers manufacturer India, fire tube boiler exporter, water tube boiler manufacturer India, electric steam boiler supplier, ASME certified boilers, high pressure boilers India, industrial boiler systems, steam boiler exporter India, oil and gas boilers, refinery boiler solutions"
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://www.oilandgasindustrialequipmentsupply.com/steam-boilers" />

                <meta property="og:title" content="Premium Industrial Boilers Manufacturer & Global Supplier" />
                <meta property="og:description" content="Exporting high-efficiency boilers to 40+ countries. ASME-certified manufacturing with 25+ years expertise in steam generation solutions." />
                <meta property="og:image" content="https://www.oilandgasindustrialequipmentsupply.com/assets/boilers-banner.jpg" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Industrial Boilers for Oil & Gas Operations | City Cat International" />
                <meta name="twitter:description" content="Global supplier of ASME-compliant boilers for refineries, power plants & manufacturing facilities. Request technical specs." />

                <script type="application/ld+json">
                    {`
    {
      "@context": "https://schema.org",
      "@type": "ProductPage",
      "name": "Industrial Boilers",
      "description": "Manufacturer and exporter of premium industrial boilers for global operations",
      "url": "https://www.oilandgasindustrialequipmentsupply.com/steam-boilers",
      "image": "https://www.oilandgasindustrialequipmentsupply.com/assets/boilers-banner.jpg",
      "brand": {
        "@type": "Brand",
        "name": "City Cat International"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "City Cat International"
      }
    }
    `}
                </script>
            </Helmet>

            <Navbar />

            {/* Hero Banner */}
            <div className="relative bg-gray-900 mt-24">
                <img
                    src={Banner}
                    alt="Industrial Steam Boilers for Oil & Gas Operations"
                    className="w-full h-96 object-cover opacity-70"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Industrial Steam Boiler Solutions
                    </h1>
                    <p className="text-xl text-white max-w-3xl">
                        Premium Fire Tube, Electric Steam & Water Tube Boilers for Oil & Gas, Power Generation & Manufacturing
                    </p>
                </div>
            </div>

            {/* Industries Served Section */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Boilers for Critical Industries
                    </h2>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-5xl mx-auto">
                        {[
                            { icon: <FaOilWell />, name: "Oil Refineries" },
                            { icon: <FaGasPump />, name: "Gas Processing" },
                            { icon: <FaIndustry />, name: "Power Plants" },
                            { icon: <FaTools />, name: "Manufacturing" },
                            { icon: <FaCertificate />, name: "Chemical Plants" },
                            { icon: <FaOilWell />, name: "Petrochemicals" }
                        ].map((industry, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center">
                                <div className="text-rose-600 text-3xl mb-3 flex justify-center">
                                    {industry.icon}
                                </div>
                                <h3 className="font-semibold text-gray-800">{industry.name}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Comprehensive Solutions Section */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Comprehensive Boiler Solutions
                    </h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
                        {[
                            {
                                icon: <FaCogs className="text-4xl mb-4" />,
                                title: "Custom Engineering",
                                desc: "Bespoke designs for specific pressure, temperature & fuel requirements"
                            },
                            {
                                icon: <FaChartLine className="text-4xl mb-4" />,
                                title: "Efficiency Optimization",
                                desc: "Advanced economizers and heat recovery systems"
                            },
                            {
                                icon: <FaShieldAlt className="text-4xl mb-4" />,
                                title: "Safety Compliance",
                                desc: "ASME, IBR & PED certified designs for hazardous environments"
                            },
                            {
                                icon: <FaHeadset className="text-4xl mb-4" />,
                                title: "24/7 Support",
                                desc: "Global technical assistance with rapid response time"
                            },
                            {
                                icon: <FaCubes className="text-4xl mb-4" />,
                                title: "Spare Parts Network",
                                desc: "Genuine components available worldwide"
                            }
                        ].map((feature, index) => (
                            <div key={index} className="bg-gray-50 p-6 rounded-lg text-center">
                                <div className="text-rose-600 flex justify-center">{feature.icon}</div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                                <p className="text-gray-700">{feature.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className="bg-white">
                <h2 className="text-center text-gray-800 text-4xl lg:text-5xl font-bold leading-tight pt-16">
                    Boiler Range
                </h2>
                <div className="my-4 mx-auto w-16 h-2 border-4 border-rose-600 mb-20"></div>

                {/* Fire Tube Boiler */}
                <section data-aos="fade-right">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                                <img
                                    alt="Fire Tube Boiler for industrial applications"
                                    src={Fire}
                                    className="absolute inset-0 h-full w-full object-contain"
                                />
                            </div>
                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Fire Tube Boilers</h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Capacity: 5,000-50,000 kg/hr</li>
                                        <li>Pressure: Up to 30 bar</li>
                                        <li>Efficiency: Up to 90%</li>
                                        <li>Fuel Options: Gas, Oil, Dual Fuel</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Our fire tube boilers feature robust construction with seamless steel tubes and advanced
                                    combustion technology for optimal thermal efficiency. Designed with large steam space and
                                    multiple passes for superior heat transfer, these boilers deliver reliable steam output
                                    for industrial processes. Ideal for small to medium steam requirements in refineries,
                                    food processing plants, and textile mills where space is constrained but reliability is critical.
                                </p>
                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Request Technical Specs
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Electric Steam Boiler */}
                <section data-aos="fade-left">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-first lg:h-full">
                                <img
                                    alt="Electric Steam Boiler for clean operations"
                                    src={Electric}
                                    className="absolute inset-0 h-full w-full object-contain"
                                />
                            </div>
                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Electric Steam Boilers</h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Capacity: 10-10,000 kg/hr</li>
                                        <li>Pressure: Up to 25 bar</li>
                                        <li>Voltage: 380-11,000 V</li>
                                        <li>Efficiency: Up to 99%</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Our electric steam boilers deliver clean, zero-emission steam with near-perfect energy
                                    conversion efficiency. Featuring advanced electrode or immersion heating technology with
                                    precise PLC control systems, these boilers provide instant steam on demand without combustion
                                    emissions. Perfect for pharmaceutical facilities, hospitals, and food processing plants
                                    where air quality regulations are stringent and steam purity is paramount.
                                </p>
                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Get Capacity-Specific Quote
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Water Tube Boiler */}
                <section data-aos="fade-right">
                    <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                            <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                                <img alt="Water Tube Boiler for high-pressure applications" src={WaterTube}
                                    className="absolute inset-0 h-full w-full object-contain" />
                            </div>
                            <div className="lg:py-16">
                                <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Water Tube Boilers</h2>

                                <div className="my-6">
                                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                                        <li>Capacity: 20,000-500,000 kg/hr</li>
                                        <li>Pressure: Up to 250 bar</li>
                                        <li>Temperature: Up to 600°C</li>
                                        <li>Fuels: Coal, Biomass, Oil, Gas</li>
                                    </ul>
                                </div>

                                <p className="mt-4 text-gray-600 text-lg text-justify">
                                    Engineered for extreme pressure and temperature applications, our water tube boilers
                                    feature membrane wall construction with advanced circulation systems for superior heat
                                    transfer. Designed to ASME Section I standards, these high-capacity boilers deliver
                                    exceptional performance in power generation plants, large refineries, and chemical
                                    processing facilities. Optional superheaters and economizers maximize thermal efficiency
                                    while reducing fuel consumption by up to 15% compared to conventional designs.
                                </p>
                                <div className="mt-8 flex justify-center">
                                    <a
                                        href="/contact"
                                        className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                                    >
                                        Request Engineering Package
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Oil & Gas Applications */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Boiler Applications in Oil & Gas
                    </h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
                        {[
                            {
                                title: "Crude Oil Heating",
                                content: "Steam boilers for viscosity reduction in pipelines and storage tanks"
                            },
                            {
                                title: "Fractionation Columns",
                                content: "High-pressure steam for distillation processes in refineries"
                            },
                            {
                                title: "Enhanced Oil Recovery",
                                content: "Steam injection boilers for thermal recovery methods"
                            },
                            {
                                title: "Cogeneration Plants",
                                content: "Combined heat and power systems for refineries"
                            },
                            {
                                title: "Desalination Units",
                                content: "Steam for multi-stage flash distillation in offshore platforms"
                            },
                            {
                                title: "Gas Processing",
                                content: "Steam for amine regeneration and glycol dehydration"
                            }
                        ].map((app, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                                <h3 className="text-xl font-bold text-rose-600 mb-3">{app.title}</h3>
                                <p className="text-gray-700">{app.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Enhanced Technical Support CTA */}
            <section className="py-16 bg-gradient-to-r from-rose-700 to-rose-900 text-white">
                <div className="container mx-auto px-4 text-center">
                    <div className="max-w-4xl mx-auto">
                        <h2 className="text-3xl md:text-4xl font-bold mb-6">
                            Need Boiler Engineering Support?
                        </h2>
                        <p className="text-xl mb-10">
                            Our ASME-certified boiler engineers provide:
                        </p>

                        <div className="grid md:grid-cols-3 gap-6 mb-12">
                            {[
                                "System Design & Layout",
                                "Efficiency Optimization",
                                "Retrofit & Upgrade Solutions",
                                "Troubleshooting & Diagnostics",
                                "Safety Compliance Audits",
                                "Maintenance Planning"
                            ].map((service, index) => (
                                <div key={index} className="flex items-start">
                                    <HiOutlineBadgeCheck className="text-2xl mt-1 mr-3 text-rose-200 flex-shrink-0" />
                                    <span>{service}</span>
                                </div>
                            ))}
                        </div>

                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                            <a
                                href="tel:+919819600149"
                                className="bg-white text-rose-700 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition duration-300"
                            >
                                Call: +91 9819600149
                            </a>
                            <a
                                href="mailto:info@oilandgasindustrialequipmentsupply.com"
                                className="border-2 border-white hover:bg-rose-800 font-bold py-3 px-8 rounded-lg transition duration-300"
                            >
                                Email Technical Team
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Project Case Studies */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                        Global Boiler Projects
                    </h2>

                    <div className="max-w-5xl mx-auto">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div className="bg-gray-50 p-6 rounded-lg">
                                <h3 className="text-xl font-bold text-rose-600 mb-3">Refinery Steam Generation System</h3>
                                <p className="text-gray-700 mb-4">
                                    <span className="font-semibold">Location:</span> Middle East<br />
                                    <span className="font-semibold">Solution:</span> 3 × 100 TPH Water Tube Boilers<br />
                                    <span className="font-semibold">Pressure:</span> 110 bar at 540°C<br />
                                    <span className="font-semibold">Features:</span> Dual fuel capability, NOx reduction system
                                </p>
                                <div className="flex items-center">
                                    <FaCheck className="text-green-600 mr-2" />
                                    <span>12% fuel savings compared to previous system</span>
                                </div>
                            </div>

                            <div className="bg-gray-50 p-6 rounded-lg">
                                <h3 className="text-xl font-bold text-rose-600 mb-3">Offshore Platform Steam System</h3>
                                <p className="text-gray-700 mb-4">
                                    <span className="font-semibold">Location:</span> North Sea<br />
                                    <span className="font-semibold">Solution:</span> Compact Fire Tube Boilers<br />
                                    <span className="font-semibold">Capacity:</span> 5,000 kg/hr at 17 bar<br />
                                    <span className="font-semibold">Features:</span> Marine-grade construction, seismic compliance
                                </p>
                                <div className="flex items-center">
                                    <FaCheck className="text-green-600 mr-2" />
                                    <span>99.6% uptime over 4 years of operation</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Boilers;